import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../molecules/Icon';

const ContactSupportButton = ({
  onClick,
}) => (
  <button className="contact-support-button" onClick={onClick}>Contact Support
    <Icon icon="phone" imgStyle="contact-support-button--icon" alt="Contact Support Button" />
  </button>
);

ContactSupportButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default ContactSupportButton;



// WEBPACK FOOTER //
// src/components/atoms/ContactSupportButton/index.jsx